import { API_URL } from '@/constants/const.js'
import axios from 'axios';

export function checkSeqCorrect(val) {
  // 格式化日期的逻辑
  let rs = false;
  if (Number.isInteger(val) && val >= 0 && val < 100000) {
    rs = true
  }
  return rs;
}

export function isValidIPv4(ip) {
  const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return regex.test(ip);
}

export function formatUTCDate(isoString) {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    // 无效日期处理，可以返回空字符串或者抛出错误等
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return year + '-' + month + '-' + day;
}

export function formatUTCDateTime(isoString) {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return '';
  }
  const year = date.getFullYear();        // 本地年份
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');      // 本地小时
  const minute = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
}

export function parseFormattedDate(dateString) {
  if (!dateString || typeof dateString !== 'string') {
    // 无效输入处理，返回 null 或者抛出错误等
    return null;
  }
  
  // 解析格式为 "YYYY-MM-DD" 的日期字符串
  const parts = dateString.split('-');
  if (parts.length !== 3) {
    return null;
  }
  
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // 月份从0开始
  const day = parseInt(parts[2], 10);
  
  // 验证日期是否有效
  const date = new Date(year, month, day);
  if (isNaN(date.getTime()) ||
      date.getFullYear() !== year ||
      date.getMonth() !== month ||
      date.getDate() !== day) {
    return null;
  }
  
  return date;
}

export function getDate(str) {
  let rs = '';
  if (str.length > 10) {
    rs = str.substr(0, 10)
  }
  return rs;
}

export function getTime(str) {
  let rs = '';
  if (str.length > 18) {
    rs = str.substr(11, 8)
  }
  return rs;

}
export function setSidbarBreadCrumb(data) {
  let rs = [];
  // if (data && data.kind) {
  //   rs += '「' + data.kind + '」';
  // }
   rs.push( data.productline_name )
   rs.push(data.code );
   let controllerversion = data.controller_sw_ver || '';
    if (controllerversion) {
      controllerversion = 'V_'+controllerversion;
    } 
   rs.push(controllerversion );

     let bootVersion = data.controller_boot_ver || '';
    if (bootVersion) {
      bootVersion = 'V_'+bootVersion;
    } 
   rs.push(bootVersion );
 
  // if (data && data.name) {
  //   rs += '-「' + data.name + '」'
  // }

  
   
  return rs;
}

export function exportFile(response) {
  const contentDisposition = response.headers['content-disposition'];
  let fileName = 'heron.xls';
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1];
    }
  }
  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function blobToString(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function () {
      reject(reader.error);
    };
    reader.readAsText(blob); // 默认按UTF-8编码读取
  })
}

export function kindMapLibrary(kind) {
  let rs = 64
  if (kind == 803) {
    rs = 960;
  }
  return rs;
}

export function formatShorTime(isoString) {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    // 无效日期处理，可以返回空字符串或者抛出错误等
    return '';
  }
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return month + '/' + day + ' ' + hour + ':' + minute + ':' + seconds;
}

export function postJsError(err, vm, info) {
  let url = API_URL["jsError"];
  let formData = new FormData();
  
  let errString = err;
  if (vm) {
    errString += "---------Component Name:" + vm.$options?.name || 'UnknownComponent'
  }
  if (info) {
    errString += "-----------info:" + info
  }
  formData.append('err', errString);  
  axios.post(url,
    formData
  )
}

export function getDashboardPage(){
 let path = 'running';
  if(localStorage.getItem('dashboard.machine.page') && localStorage.getItem('dashboard.machine.page') !== 'undefined') {
      path = localStorage.getItem('dashboard.machine.page');
  }
  return path;
}


export function setDashboardPage(path){  
  localStorage.setItem('dashboard.machine.page',path);
}

export async function copyContent(content){
  try {
    await navigator.clipboard.writeText(content);
    return true;
  } catch {
    return false;
  }
}

export function jsonParseSafe(str) {
  let rs = null;
  try {
    rs = JSON.parse(str);
  } catch (e) {
    rs = null;
  }
  return rs;
}

export function KindOf803(kind){
  return kind == 803
}

export function KindOf803Series(kind){
  return kind == 803 || kind == 802 || kind == 62
}

export function KindOf802(kind){
	return kind == 802
}

export function KindOf62(kind){
	return kind == 62
}

export function KindOf670Series(kind){
  return kind == 670
}

export function formatDecimals(value, decimals = 2) {
  if (value === undefined || value === null || value === '') {
    return (0).toFixed(decimals);
  }
  const num = parseFloat(value);
  if (isNaN(num) || !isFinite(num)) {
    return (0).toFixed(decimals);
  }
  const factor = Math.pow(10, decimals);
  return (Math.round(num * factor) / factor).toFixed(decimals);
}

export function isNonNegativeInteger(inputValue){
  if (inputValue === '') return false;
  const reg = /^(0|[1-9]\d*)$/;
  return reg.test(inputValue);
}